import { render, staticRenderFns } from "./CreateNewAdministrator.vue?vue&type=template&id=56504794&scoped=true&lang=true&"
import script from "./CreateNewAdministrator.vue?vue&type=script&lang=js&"
export * from "./CreateNewAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewAdministrator.vue?vue&type=style&index=0&id=56504794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56504794",
  null
  
)

export default component.exports